import { isAfter } from "owa-datetime";
import { getOwaDateFromExtendedDateTime } from "owa-datetime-utils";

import type { ExtendedDateTime } from "owa-graph-schema";

export function isValidCollaboratorWorkingHoursSegment(segment: {
    start: ExtendedDateTime;
    end: ExtendedDateTime;
}): boolean {
    return isAfter(getOwaDateFromExtendedDateTime(segment.end), getOwaDateFromExtendedDateTime(segment.start));
}
